import * as semrush from '@anm/helpers/semrush';

type HelperProps = {
  previewUrl?: string;
  isVertical: boolean;
};

export const DEFAULT_POSTER_16x9 = 'https://assets.animatron.com/images/live/default-preview-for-live-events-16x9.jpg';
export const DEFAULT_POSTER_9x16 = 'https://assets.animatron.com/images/live/default-preview-for-live-events-9x16.jpg';

export const DEFAULT_POSTER_UNBRANDED_16x9 =
  'https://assets.animatron.com/images/live/default-preview-for-live-events-unbranded-16x9.jpg';
export const DEFAULT_POSTER_UNBRANDED_9x16 =
  'https://assets.animatron.com/images/live/default-preview-for-live-events-unbranded-9x16.jpg';

const getWebinarPreview = ({ previewUrl, isVertical }: HelperProps) => {
  if (previewUrl) return previewUrl;

  const isSemRush = semrush.isSemrushIframeWithProps();

  switch (isSemRush) {
    case true:
      return isVertical ? DEFAULT_POSTER_UNBRANDED_9x16 : DEFAULT_POSTER_UNBRANDED_16x9;
    default:
      return isVertical ? DEFAULT_POSTER_9x16 : DEFAULT_POSTER_16x9;
  }
};

export default getWebinarPreview;
